/** @format **/
import React, { FunctionComponent, ReactElement } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import I18n from '../../../components/Translate/I18n';
import { PlatformPoolFile } from '../../../interfaces/collections/PlatformPoolFilesCollectionInterface';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';

type ViewReportDialogType = {
    open: boolean;
    closeCallback: () => void;
    poolFile: PlatformPoolFile | null;
};

interface ReportsState {
    error: Array<{ msg: string; time: string }> | null;
}

export const ViewReportDialog: FunctionComponent<ViewReportDialogType> = ({ open, closeCallback, poolFile }): ReactElement => {
    if (!poolFile) {
        return <React.Fragment />;
    }

    const reports = JSON.parse(poolFile.processReport ?? '{}') as ReportsState;

    return (
        <Dialog fullWidth={true} maxWidth="sm" open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                <I18n trans="pools:add.report_from_import" />
            </DialogTitle>
            <DialogContent>
                {reports && !reports.error && (
                    <React.Fragment>
                        <I18n trans="pools:add.import_ok" />
                    </React.Fragment>
                )}

                <GridContainer>
                    {reports &&
                        reports.error?.map((item) => {
                            return (
                                <React.Fragment>
                                    <GridItem xs={12}>{item.msg}</GridItem>
                                </React.Fragment>
                            );
                        })}
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={closeCallback} callbackParam={{}} label="general:common.close" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
